<template>
  <main>
    <div
      class="koc-view koc-events-schedule-tabs-view"
      data-observe-resize
    >
      <div
        v-if="state.hasEvent && state.tabs.length > 1"
        class="koc-track-tabs-container"
      >
        <tabs-component
          :ref="state.tabsRef"
          :default-tab-hash="state.activeTab"
          :kol-style="true"
          :store-local="false"
          :window-location="false"
          @changed="tabChanged"
          @clicked="tabClicked"
        >
          <tab-component
            v-for="tab in state.tabs"
            :id="tab.id"
            :key="tab.id"
            :hash="tab.id"
            :name="tab.name"
          >
            <div
              v-for="(row, index) in tab.rows"
              :key="index"
              class="koc-block koc-tab-row-container"
            >
              <div
                v-for="(track, index) in row"
                :key="index"
                :style="{flexBasis: (100 / row.length) + '%'}"
                class="koc-tab-track-container"
              >
                <event-sessions-column-component
                  v-if="track.track"
                  :bg-color="calculateTrackColor(track.track, track.trackColor)"
                  :columns="Number(track.columns)"
                  :sessions="calculateTrackSessions(track.track, track.day, track.include, track.exclude)"
                  :show-buttons="tabsConfig.showButtons"
                  :show-date="!state.isReplay"
                  :title="calculateTrackTitle(track.track, track.title)"
                />
              </div>
            </div>
          </tab-component>

          <div class="koc-block koc-tab-bottom-buttons-container">
            <div
              v-for="tab in state.tabs"
              :key="tab.id"
              :class="[state.activeTab === '#' + tab.id ? 'active' : '', 'koc-tab-bottom-button']"
              @click="tabClicked('#' + tab.id)"
            >
              {{ tab.name }}
            </div>
          </div>
        </tabs-component>
      </div>
      <div
        v-else-if="state.hasEvent && state.tabs.length"
        class="koc-track-tabs-container"
      >
        <div
          v-for="(row, index) in state.tabs[0].rows"
          :key="index"
          class="koc-block koc-tab-row-container"
        >
          <div
            v-for="(track, index) in row"
            :key="index"
            :style="{flexBasis: (100 / row.length) + '%'}"
            class="koc-tab-track-container"
          >
            <event-sessions-column-component
              v-if="track.track"
              :bg-color="calculateTrackColor(track.track, track.trackColor)"
              :columns="Number(track.columns)"
              :sessions="calculateTrackSessions(track.track, track.day, track.include, track.exclude)"
              :show-buttons="tabsConfig.showButtons"
              :show-date="!state.isReplay"
              :title="calculateTrackTitle(track.track, track.title)"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="koc-tab-wrapper skeleton-container"
      >
        <div
          v-for="(row, index) in state.defaultSkeleton"
          :key="index"
          class="koc-block koc-tab-row-container"
        >
          <div
            v-for="(track, index) in row"
            :key="index"
            :style="{flexBasis: (100 / row.length) + '%'}"
            class="koc-tab-track-container"
          >
            <SkeletonLoader
              :list-items="3"
              class="koc-flex-fullwidth-column"
              item="sessions-list"
            />
          </div>
        </div>
      </div>
      <div
        v-if="state.showPDF && state.downloadPDF"
        class="koc-events-schedule-tabs-pdf"
      >
        <div class="koc-events-schedule-tabs-pdf-section">
          <h1 class="koc-events-schedule-tabs-pdf-title">
            WANT A PRINTABLE PDF VERSION OF OUR FULL SCHEDULE? NO
            PROBLEM!
          </h1>
          <div class="koc-events-schedule-tabs-pdf-link-container">
            <a
              :href="state.downloadPDF"
              class="koc-events-schedule-tabs-pdf-link"
              target="_blank"
            >DOWNLOAD SCHEDULE PDF</a>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script src="./event-schedule-tabs.js"></script>
<style lang="scss" scoped src="./event-schedule-tabs.scss"></style>
